export const DEMO_PAGES: {
  path: string;
  data: {
    title: string;
  };
}[] = [
  {
    path: 'alert',
    data: {
      title: 'ui-alert',
    },
  },
  {
    path: 'badge',
    data: {
      title: 'ui-badge',
    },
  },
  {
    path: 'button',
    data: {
      title: 'ui-button',
    },
  },
  {
    path: 'breadcrumb-nav',
    data: {
      title: 'ui-breadcrumb-nav; ui-breadcrumb',
    },
  },
  {
    path: 'calendar-input',
    data: {
      title: 'ui-calendar-input; ui-date-input',
    },
  },
  {
    path: 'calendar-range-input',
    data: {
      title: 'ui-calendar-range-input (WIP)',
    },
  },
  {
    path: 'chart',
    data: {
      title: 'ui-chart',
    },
  },
  {
    path: 'checkbox',
    data: {
      title: 'ui-checkbox',
    },
  },
  {
    path: 'checkbox-group',
    data: {
      title: 'ui-checkbox-group; ui-checkbox-group-option',
    },
  },
  {
    path: 'confirm-dialog',
    data: {
      title: 'ui-confirm-dialog',
    },
  },
  {
    path: 'dialog',
    data: {
      title: 'ui-simple-dialog; uiDialog',
    },
  },
  {
    path: 'dropzone',
    data: {
      title: 'ui-dropzone; ui-dropzone-file',
    },
  },
  {
    path: 'file-input',
    data: {
      title: 'file-input (WIP)',
    },
  },
  {
    path: 'help-button',
    data: {
      title: 'ui-help-button',
    },
  },
  {
    path: 'icons',
    data: {
      title: 'icons',
    },
  },
  {
    path: 'input-phone',
    data: {
      title: 'ui-input-phone',
    },
  },
  {
    path: 'input',
    data: {
      title: 'ui-input-simple',
    },
  },
  {
    path: 'menu-list',
    data: {
      title: 'ui-menu-list; ui-menu-list-item',
    },
  },
  {
    path: 'notification',
    data: {
      title: 'ui-notification',
    },
  },
  {
    path: 'popover',
    data: {
      title: 'ui-popover; uiPopover; ui-simple-popover-layout',
    },
  },
  {
    path: 'radio-group',
    data: {
      title: 'ui-radio-group; ui-radio',
    },
  },
  {
    path: 'tab-group',
    data: {
      title: 'ui-tab-group; ui-tab',
    },
  },
  {
    path: 'textarea',
    data: {
      title: 'ui-textarea',
    },
  },
  {
    path: 'toggle',
    data: {
      title: 'ui-toggle; ui-toggle-label',
    },
  },
  {
    path: 'tooltip',
    data: {
      title: 'ui-tooltip; uiTooltip',
    },
  },
  {
    path: 'select',
    data: {
      title: 'ui-select',
    },
  },
  {
    path: 'skeleton',
    data: {
      title: 'ui-skeleton',
    },
  },
  {
    path: 'stepper',
    data: {
      title: 'ui-stepper; ui-stepper-step',
    },
  },
  {
    path: 'switch-bar',
    data: {
      title: 'ui-switch-bar; ui-switch-bar-option',
    },
  },
];
